import { At, ChatCircle, CheckCircle } from "@phosphor-icons/react";
import { Avatar, AvatarBadge, AvatarFallback, AvatarImage, initials } from "@hulahoop/ui";
import { PersonHover } from "@/components/shared/entity/PersonHover";
import type { PersonLabels } from "@/domain/types/person";

export function ShellCommentActor({
  name,
  avatar,
  type,
  labels,
}: {
  name: string;
  avatar?: string;
  type: string;
  labels: PersonLabels;
}) {
  const Icon =
    type === "comment_mentioned" ? At : type === "comment_resolved" ? CheckCircle : ChatCircle;
  return (
    <PersonHover person={{ name, photo: avatar }} labels={labels}>
      <Avatar size="sm">
        {avatar && <AvatarImage src={avatar} alt="" />}
        <AvatarFallback>{initials(name)}</AvatarFallback>
        <AvatarBadge variant="glyph" aria-hidden>
          <Icon weight="bold" />
        </AvatarBadge>
      </Avatar>
    </PersonHover>
  );
}
